// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@west/App/Components/Notify";
import dataTableStyles from "@west/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { recentQuotesStyles } from "@west/Overrides/Widgets/Common/RecentQuotes";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

recentQuotesStyles.noQuotesGridItem = {
    width: 12,
    css: css`
        text-align: center;
        padding: 0;
    `,
};

recentQuotesStyles.noQuotesText = {
    ...getNotifyStyle("info"),
};

recentQuotesStyles.dataTable = {
    ...dataTableStyles.dataTable,
};

recentQuotesStyles.titleTypographyStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-end;
            flex-wrap: wrap;
            width: 100%;
            margin-bottom: 16px;
        `,
    },
    title: {
        variant: "h3",
        size: 20,
    },
};
